import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function Empty(props: IconContainerProps) {
  return <IconContainer {...props} />
}
